import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '../../services/firebase.service';

@Component({
	selector: 'app-sidebar-menu',
	templateUrl: './sidebar-menu.component.html',
	styleUrls: ['./sidebar-menu.component.css']
})
export class SidebarMenuComponent implements OnInit {
	username:string = 'Guest';

	constructor(private firebaseService : FirebaseService) {
	}

	ngOnInit() {
		this.firebaseService.getAuth().subscribe((user) => {
			if (user)
			{
				var a = user.email.replace(/@.*/, '') ;
				this.username = a.replace(/\./g, ' ') ;
			}
			else
			{
				this.username = 'Guest';
			}
		});
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/sidebar-menu/sidebar-menu.component.ts